(async () => {
    const { Core } = await importModule('Core');
    const { 
        fetchHTML, 
        $isEmpty, 
        $show, 
        $clone 
    } = await importModule('Utils');

    const RQ_SECTION_ID = 'r_cart-notification-product-recommendations';

    const CN_ADDED_ITEMS = '@added-items:'

    const PARAM_IMG_SIZE = 150;

    const SEL_PRODUCT_IMAGE         = '[data-product-image]';
    const SEL_PRODUCT_LINK          = '[data-product-link]';
    const SEL_PRODUCTS              = '[data-products]';
    const SEL_PRODUCT_TITLE         = '[data-product-title]';
    const SEL_PRODUCT_VARIANT_TITLE = '[data-product-variant-title]';
    const SEL_CART_ITEMS_COUNT      = '[data-cart-items-count]';
    const SEL_CART_TOTAL            = '[data-cart-total]';
    const SEL_REC_PRODUCTS          = '[data-recommendation-products]';
    const SEL_REC_CONTAINER         = '[data-recommendation-container]';

    customElements.define('cart-notification', class extends Core {
        
        subscriptions = {
            'cart:update':  '_cartUpdateHandler'
        }

        elements = {
            template: '[data-template]',
            productTemplate: '[data-product-template]'
        }

        render() {
            this.subscribe('cart:update', { global: true });
        }

        async _cartUpdateHandler(data) {
            if (this._srcIsCart(data.src)) return;
            await this
                ._setData(data)
                ._initContainer()
                ._setContent()
                ._setRecommendations();
            
            this._openModal();
        }

        _srcIsCart(src) {
            return src.toLowerCase().includes('cart-qty');
        }

        _setContent() {
            this._setProducts()
                ._setSubtitle()
                ._setCart();
            return this;
        }

        async _setRecommendations() {
            const $doc = await fetchHTML(`/recommendations/products?${new URLSearchParams({
                product_id: this.recProductId,
                limit: 20,
                section_id: RQ_SECTION_ID
            })}`);

            const $section = $doc.getElementById(`shopify-section-${RQ_SECTION_ID}`);

            if(!$isEmpty($section)) {
                this.$container
                    .querySelector(SEL_REC_PRODUCTS)
                    .replaceChildren(...$section.cloneNode(true).childNodes);

                $show(
                    this.$container
                        .querySelector(SEL_REC_CONTAINER)
                );
            }
            return this;
        }
        
        _openModal() {
            this.publish('modal:open', {
                content: this.$container,
                close: false,
                animation: 'top',
                positionY: 'top'
            })

            return this;
        }

        _setData(data) {
            this.addedProducts = data.items;
            this.cartItems = data.getItemCount();
            this.cartTotal = data.getSubtotal();
            this.recProductId = data.items[0]['product_id'];
            return this;
        }

        _initContainer() {
            this.$container = $clone(this.$template);

            // Adding number of products css class (only for styling)
            this.$container
                .firstElementChild
                .classList
                .add(CN_ADDED_ITEMS + this.addedProducts.length);

            return this;
        }

        _setProducts() {
            this.$container
                .querySelector(SEL_PRODUCTS)
                .replaceChildren(
                    ...this.addedProducts.map(
                        this._setProduct.bind(this)
                    )
                );
            
            return this;
        }

        _setSubtitle() {

            const [{ 
                product_title: productTitle, 
                variant_title: variantTitle,
                selling_plan_allocation: sellingPlanAllocation
             }] = this.addedProducts;
            
            this.$container
                .querySelector(SEL_PRODUCT_TITLE)
                .textContent = productTitle;
            
            if(variantTitle) {
                this.$container
                    .querySelector(SEL_PRODUCT_VARIANT_TITLE)
                    .textContent = variantTitle;
            }
            
            return this;
        }

        _setProduct({
            image,
            url
        }) {
            const $productContainer = $clone(this.$productTemplate);
            
            $productContainer
                .querySelector(SEL_PRODUCT_IMAGE)
                .src = this._getOptimizedImage(image);
            
            $productContainer
                .querySelector(SEL_PRODUCT_LINK)
                .href = url;

            return $productContainer;
        }

        _getOptimizedImage(imgSrc) {
            const imgFormat = imgSrc.includes('.jpg') ? '.jpg' : '.png';
            return imgSrc.replace(imgFormat, `_${PARAM_IMG_SIZE}x${imgFormat}`)
        }

        _setCart() {
            this.$container
                .querySelector(SEL_CART_ITEMS_COUNT)
                .textContent = this.cartItems;
            
            this.$container
                .querySelector(SEL_CART_TOTAL)
                .textContent = this.cartTotal;

            return this;
        }
    })
})();